<template>
  <div class="logo-section">
    <img
      src="/ria-logo-v2-dark-background.svg"
      alt="logo"
    />
    <h1>RiA</h1>
  </div>
</template>

<script>
  export default {
    name: 'AppLogo',
    props: {
      dark: Boolean,
    },
  };
</script>

<style lang="scss">
  .logo-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16.99px;
    margin: 1em auto;

    img {
      width: 60px;
    }

    h1 {
      color: #ffffff;
      font-style: normal;
      font-weight: 500;
      font-size: 23.7919px;
      line-height: 27px;
    }
  }
</style>
